module.exports = __webpack_public_path__ + "static/media/ambulance.12033e3f.svg";